import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
export function LinkButton({ className, children, onClick, type = 'button', negative, disabled, gray, }) {
    const colorClass = (() => {
        if (disabled) {
            return 'text-gray-400 dark:text-gray-500';
        }
        if (gray) {
            return 'text-gray-600 dark:text-gray-500';
        }
        if (negative) {
            return 'text-red-600 dark:text-red-500';
        }
        return 'text-blue-600 dark:text-blue-500';
    })();
    return (_jsx("button", { className: clsx('font-medium', { 'hover:underline': !disabled }, colorClass, className), 
        // a type is being provided but eslint doesn't know
        // eslint-disable-next-line react/button-has-type
        type: type, onClick: onClick, disabled: disabled, children: children }));
}
